export default __webpack_public_path__ + "static/media/gradient_bottom.de159ba1.svg";